<template>
  <section>    

        <v-container fluid  class="info lighten-5 " height="600">
          <v-row  >      
          

            <v-col class="hidden-sm-and-down" align="left" justify="left">
              <v-responsive >
            <v-img 
      src="https://firebasestorage.googleapis.com/v0/b/saascadetech-com.appspot.com/o/AffordableWebDevelopment.webp?alt=media&token=539b91b5-cbe2-4de9-9c11-4b231c929958"
      srcset="https://firebasestorage.googleapis.com/v0/b/saascadetech-com.appspot.com/o/AffordableWebDevelopment.png?alt=media&token=539b91b5-cbe2-4de9-9c11-4b231c929958"
      alt-text="AFFORDABLE WEB DESIGN"
              width="900"
              height="600">
          </v-img>   
              </v-responsive>
            </v-col>  
            <v-col class="pa-md-12 text-xs-center" align="center" justify="center"  >
          <h2 class=" black--text mb-2 heading text-xs-center" style="font-weight: 1000;">Stunning websites made easy & affordable with</h2>
           <v-spacer></v-spacer>
            <h1 class=" primary--text mb-2 display-1 " style="font-weight: 1000; "> SaasCade Tech</h1>
            <h6 class=" black--text title mb-3 " style="font-weight: 500; ">The most affordable website and ecommerce solution online</h6>
          <v-col  class="pa-md-12">
            <v-btn  class=" rounded pa-md-4 accent mt-5" large  href="/explore-websites">
              Get Started
            </v-btn>
             <v-btn  class="rounded pa-md-4 mx-2 info mt-5" large  href="/contactus">
              Contact Us
            </v-btn>
          </v-col>
            </v-col>         
           
          </v-row>
    </v-container>    

       <v-container fluid  class="info lighten-5 " height="600">
          <v-row  >           
          
            <v-col  >
            <h3  class=" info--text subtitle-1 mb-2 " style="font-weight: 600; ">WORK WITH US.</h3>
            <h1 class=" black--text mb-2 display-3" style="font-weight: 300; ">Get your business online today</h1>
            <h3 class=" black--text title mb-2 " style="font-weight: 300; ">We, at SaasCade Tech, always strive to add value to your every single penny, with our experience we know what works in digital world and what not, what is essential and what isn't, so feel free to contact us so that we can help your business gain a strong digital footprint.</h3>
           
            </v-col>

            <v-col align="center" justify="center">
              <v-responsive >
            <v-img 
          src="https://firebasestorage.googleapis.com/v0/b/saascadetech-com.appspot.com/o/affordable-webdesign2.webp?alt=media&token=b25a2886-67b4-487d-b8e5-87dde5c808ac"
          srcset="https://firebasestorage.googleapis.com/v0/b/saascadetech-com.appspot.com/o/affordable-webdesign2.png?alt=media&token=201a2943-5049-4af7-889f-6fa7e53cbcb7"  
              width="700"
              height="400">
          </v-img>   
              </v-responsive>
            </v-col>           
           
          </v-row>
    </v-container>    

        <v-container fluid class="white pa-md-4" height="500" >
          <v-spacer></v-spacer>
          <div>
            <h3 class=" black--text mb-2 display-1 text-xs-center" justify="center" align="center" style="font-weight: 1000;">SAASCADE TECH ADVANTAGE </h3>
        </div>
        <v-layout  flat color="twhite" class="hidden-sm-and-down">
            <v-spacer></v-spacer>
            <v-row class="text-xs-center" justify="center" align="center">
                <v-col xs12 sm12 class = "pa-md-4" justify="center" align="center" >
                <v-progress-circular
                    :rotate="360"
                    :size="100"
                    :width="20"
                    :value="100"
                    color="success"
                  ><h2>100+</h2>  </v-progress-circular>
                <h3 class="black--text mb-2 headline " style="font-weight: 600;">Projects </h3>
                <h6 class="black--text body-1 "> We have completed 100+ projects successfully, helping small businesses all around the globe.</h6>
                </v-col>      
                <v-col xs12 sm12 class = "pa-md-6" justify="center" align="center">
                  <v-progress-circular
                    :rotate="360"
                    :size="100"
                    :width="20"
                    :value="500"
                    color="success"
                  > <h2>500+</h2> </v-progress-circular>
                <h3 class="black--text mb-2 headline" style="font-weight: 600;">Templates </h3>
                <h6 class="black--text body-1" > You can choose from 500+ readymade templates which suits all your needs </h6>
                </v-col>
                  <v-col xs12 sm12 class = "pa-md-6"  justify="center" align="center">
                  <v-progress-circular
                    :rotate="360"
                    :size="100"
                    :width="20"
                    :value="100"
                    color="success"
                  ><h2>3M+</h2> </v-progress-circular>
                <h3 class="black--text mb-2 headline" style="font-weight: 600;">User Views Served </h3>
                <h6 class="black--text  body-1"> We've served around 3 million users from our servers. </h6>
                </v-col>                                      
            </v-row>
          </v-layout>
          <v-spacer></v-spacer>
          <v-divider></v-divider>
          <v-spacer></v-spacer>
          <v-layout  flat >
            
            <v-spacer></v-spacer>
            <v-row   class="text-xs-center" >
                <v-col xs12 sm12>
                  
                  <v-banner  two-line>
                  <v-avatar
                    slot="icon"
                    color="success accent-4"
                    size="40"
                  >
                    <v-icon
                      icon="mdi-lock"
                      color="white"
                    >
                      mdi-lock
                    </v-icon>
                  </v-avatar>
                  <h3 class="success--text mb-2 headline" style="font-weight: 600;">Free SSL </h3>
                  Internet is increasingly becoming a safe haven for malicious operations, get Free SSL certificate  when you host with us forever and safeguard your clients.
                  </v-banner>
                </v-col>      
                 <v-col xs12 sm12  >
                  
                <v-banner two-line>
                  <v-avatar
                    slot="icon"
                    color="success accent-4"
                    size="40"
                  >
                    <v-icon
                      icon="mdi-server"
                      color="white"
                    >
                      mdi-server
                    </v-icon>
                  </v-avatar>
                  <h3 class="success--text mb-2 headline" style="font-weight: 600;">Free Hosting </h3>
                  Get free hosting for your website upto 1 year when you develop your site with us.
                   </v-banner>
                </v-col>   
                  <v-col xs12 sm12 >
                  
                   <v-banner two-line>
                  <v-avatar
                    slot="icon"
                    color="success accent-4"
                    size="40"
                  >
                    <v-icon
                      icon="mdi-cash"
                      color="white"
                    >
                      mdi-cash
                    </v-icon>
                  </v-avatar>
                  <h3 class="success--text mb-2 headline" style="font-weight: 600;">Affordable Pricing </h3>
                  We're determined to keep our prices affordable to help small businesses.
                   </v-banner>
                </v-col>                                       
            </v-row>
            
          </v-layout>

           <v-spacer></v-spacer>
            <v-layout  flat  >
            <v-spacer></v-spacer>
            <v-row  class="text-xs-center" >
                <v-col  >
                  
                   <v-banner two-line>
                  <v-avatar
                    slot="icon"
                    color="success accent-4"
                    size="40"
                  >
                    <v-icon
                      icon="mdi-web"
                      color="white"
                    >
                      mdi-web
                    </v-icon>
                  </v-avatar>
                  <h3 class="success--text mb-2 headline" style="font-weight: 600;">CDN </h3>
                  We can integrate CDN to all websites, increasing in greater security and speed.
                   </v-banner>
                </v-col>      
                 <v-col  >
                  
                   <v-banner two-line>
                  <v-avatar
                    slot="icon"
                    color="success accent-4"
                    size="40"
                  >
                    <v-icon
                      icon="mdi-mail"
                      color="white"
                    >
                      mdi-mail
                    </v-icon>
                  </v-avatar>
                  <h3 class="success--text mb-2 headline" style="font-weight: 600;">Free Email </h3>
                  Get your own email@yourdomainname for absolutely free, forever.
                   </v-banner>
                </v-col>   
                  <v-col  >
                  
                   <v-banner two-line>
                  <v-avatar
                    slot="icon"
                    color="success accent-4"
                    size="40"
                  >
                    <v-icon
                      icon="mdi-google"
                      color="white"
                    >
                      mdi-google
                    </v-icon>
                  </v-avatar>
                  <h3 class="success--text mb-2 headline" style="font-weight: 600;">SEO </h3>
                  All our products come with a basic seo pack which will result in increased rankings in google search for your website.
                   </v-banner>
                </v-col>                                       
            </v-row>
            
          </v-layout>
        </v-container>        

      <section flat class="info lighten-5 pa-md-4">

          <v-spacer></v-spacer>
          <div>
            <h3 class=" black--text mb-2 display-1 text-xs-center" justify="center" align="center" style="font-weight: 1000;">PRICING</h3>
            <h6 class= "black--text mb-2 title text-xs-center" justify="center" align="center" style="font-weight: 600;">Feel free to contact us for more details</h6>
         </div>
          <v-container fluid>     
          
          <v-row flat column>
          <v-col class="text-center">
          <v-card>
          <v-toolbar dense class=" primary lighten-1 white--text" >
            <v-toolbar-title>
              HTML Websites      
              
            </v-toolbar-title>
             <v-spacer></v-spacer>
             <v-chip
                class="ma-4"
                color="green white--text"
              >
                Starter
              </v-chip>
              <h2>  <span
                    class="font-weight-bold "
                    v-if="$store.state.currency == 'INR'"
                  >
                    {{ $store.state.currencySymbol }}{{ statSite.INR}}</span
                  >
                  <span class="font-weight-bold " v-else-if ="$store.state.currency == 'PHP'">
                    {{ $store.state.currencySymbol }}{{ statSite.PHP }}</span
                  >
                   <span class="font-weight-bold " v-else-if ="$store.state.currency == 'AUD'">
                    {{ $store.state.currencySymbol }}{{ statSite.AUD }}</span
                  >
                   <span class="font-weight-bold " v-else>
                    {{ $store.state.currencySymbol }}{{ statSite.USD }}</span
                  ></h2>
            
          </v-toolbar>
          <v-list class="text-left">
            <v-list-item>
              <v-list-item-title
                >100's of templates to choose from</v-list-item-title
              >
              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Bootstrap</v-list-item-title>

              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Free HTTPS</v-list-item-title>
              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Hosting</v-list-item-title>
              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>SEO</v-list-item-title>
              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Free CDN</v-list-item-title>
              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Free Email</v-list-item-title>
              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-list-item>
          </v-list>
          <v-btn
          block
          class="accent"
          to="/explore-static-websites"
          >
          Get Started
          </v-btn>
        </v-card>
      </v-col>
      <v-col  class="text-center">
        <v-card>
          <v-toolbar dense color="primary  lighten-1 white--text">
            <v-toolbar-title>Wordpress</v-toolbar-title>
            <v-spacer></v-spacer>
             <v-chip
                class="ma-4 white--text"
                color="accent"
              >
                Popular
              </v-chip>
              <h2> <span
                    class="font-weight-bold "
                    v-if="$store.state.currency == 'INR'"
                  >
                    {{ $store.state.currencySymbol }}{{ wpSite.INR}}</span
                  >
                  <span class="font-weight-bold " v-else-if ="$store.state.currency == 'PHP'">
                    {{ $store.state.currencySymbol }}{{ wpSite.PHP }}</span
                  >
                   <span class="font-weight-bold " v-else-if ="$store.state.currency == 'AUD'">
                    {{ $store.state.currencySymbol }}{{ wpSite.AUD }}</span
                  >
                   <span class="font-weight-bold " v-else>
                    {{ $store.state.currencySymbol }}{{ wpSite.USD }}</span
                  ></h2>
          </v-toolbar>
          <v-list class="text-left">
            <v-list-item>
              <v-list-item-title
                >100's of templates to choose from</v-list-item-title
              >
              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Wordpress</v-list-item-title>
              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-title
                >All the features included in websites</v-list-item-title
              >
              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Admin Dashboard</v-list-item-title>
              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Analytics</v-list-item-title>
              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Unlimited Pages</v-list-item-title>
              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Live Chat </v-list-item-title>
              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-list-item>
          </v-list>
           <v-btn
          block
          class="accent"
          to="/explore-websites"
          >
          Get Started
          </v-btn>
        </v-card>
      </v-col>
     
      <v-col  class="text-xs-center">
        <v-card >
          <v-toolbar dense color="primary  lighten-1 white--text">
            <v-toolbar-title>E-Commerce</v-toolbar-title>
            <v-spacer></v-spacer>
             <v-chip
                class="ma-4 white--text"
                color="green"
              >
                Online Store
              </v-chip>
              <h2> <span
                    class="font-weight-bold "
                    v-if="$store.state.currency == 'INR'"
                  >
                    {{ $store.state.currencySymbol }}{{ ecomSite.INR}}</span
                  >
                  <span class="font-weight-bold " v-else-if ="$store.state.currency == 'PHP'">
                    {{ $store.state.currencySymbol }}{{ ecomSite.PHP }}</span
                  >
                   <span class="font-weight-bold " v-else-if ="$store.state.currency == 'AUD'">
                    {{ $store.state.currencySymbol }}{{ ecomSite.AUD }}</span
                  >
                   <span class="font-weight-bold " v-else>
                    {{ $store.state.currencySymbol }}{{ ecomSite.USD }}</span
                  ></h2>
          </v-toolbar>
          <v-list class="text-left">
            <v-list-item>
              <v-list-item-title
                >100's of templates to choose from</v-list-item-title
              >
              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-title
                >Woo-Commerce</v-list-item-title
              >

              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>All the features included in HTML Websites & Wordpress</v-list-item-title>
              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Payment Gateway Integration</v-list-item-title>
              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Shipping</v-list-item-title>
              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Unlimited Products</v-list-item-title>
              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Order Management Dashboard</v-list-item-title>
              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-list-item>
             
          </v-list>
           <v-btn
          block
          class="accent"
          to="/explore-ecommerce"
          >
          Get Started
          </v-btn>
        </v-card>
      </v-col>
          </v-row>
      </v-container>
      </section>

      

      <section  class="white pa-md-4" height="400">
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-layout>
          <v-row class = "pa-md-4" align="center" justify="center">           
          
            <v-col class = "pa-md-4" align="center" justify="center">
            <h1  class=" black--text mb-2 display-3" style="font-weight: 300; ">Ready to talk?</h1>
            <h3  class=" info--text display-3 mb-2 " style="font-weight: 300; ">Our team is here to help.</h3>
           
            </v-col>

            <v-col align="center" justify="center">
            <span>
             <v-btn color="white" class=" mt-5" x-large  href="/contactus">
              Contact Us
            </v-btn>
            <v-spacer></v-spacer>
              <v-btn color="info" class=" mt-5" x-large  href="/explore-websites">
                Get Started
              </v-btn>
            </span>
            </v-col>

         
            
           
          </v-row>
        </v-layout>
      </section>      




    
  </section>
 


 
 
 

  </template>

<script>
export default {
  name: "home",
  data() {
   return {
      ecomSite:
      {
        AUD:149,
        INR:6999,
        USD:149,
        PHP:5999
      },
      statSite:
      {
        AUD:69,
        INR:1999,
        USD:69,
        PHP:1999
      },
      wpSite:
      {
        AUD:99,
        INR:3499,
        USD:99,
        PHP:2999
      }
    }
  },
  methods: {
    checkIfCenter(index){
      return index==1;
    }
  }
};
</script>
